'use strict'

/**
 * Project easytitle24 app
 * Created by hielo on 2018-09-19
 */

import ProjectList from './list.vue'
import NewProject from './new-project.vue'
import ProjectPreview from './preview.vue'
import ActiveProject from './active-project.vue'

const routes = [
	{
		path: '/project/list',
		name: 'project.list',
		component: ProjectList,
		meta: { authRequired: true }
	},
	{
		path: '/project/new',
		name: 'project.new',
		component: NewProject,
		meta: { authRequired: true }
	},
	{
		path: '/project/preview/:projId',
		name: 'project.preview',
		component: ProjectPreview,
		meta: { authRequired: true },
		props: true
	},
	{
		path: '/active-project',
		name: 'activeProject',
		component: ActiveProject,
		meta: { authRequired: true }
	}
]

export default routes



// WEBPACK FOOTER //
// ./src/app/project/index.js